import classes from './creative.scss';

export enum Layout {
  Unknown,
  DesktopLessThan330,
  DesktopBetween330and400,
  DesktopBetween400And500,
}
export function getLayout(width: number): Layout {
  if (width < 1) {
    return Layout.Unknown;
  }

  if (width < 330) return Layout.DesktopLessThan330;
  if (width < 400) return Layout.DesktopBetween330and400;

  return Layout.DesktopBetween400And500;
}

export const LayoutClassName = {
  [Layout.Unknown]: '',

  [Layout.DesktopLessThan330]: classes.desktopLessThan330,
  [Layout.DesktopBetween330and400]: classes.desktopBetween330And400,
  [Layout.DesktopBetween400And500]: classes.desktopBetween400And500,
};

export const LayoutLineHeightQuestion = {
  [Layout.Unknown]: 19,

  [Layout.DesktopLessThan330]: 16,
  [Layout.DesktopBetween330and400]: 16,
  [Layout.DesktopBetween400And500]: 19,
};

export const LayoutLineHeightAnswer = {
  [Layout.Unknown]: 16,

  [Layout.DesktopLessThan330]: 15,
  [Layout.DesktopBetween330and400]: 15,
  [Layout.DesktopBetween400And500]: 16,
};
